import { Roles } from '@/_shared/constants/roles';

export enum UserStatus {
  Enabled = 'Enabled',
  Pending = 'Pending',
  Disabled = 'Disabled',
}

export type UsersList = {
  data: User[];
  totalItems: number;
};

export type User = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  roles: Roles[];
  status: `${UserStatus}` | UserStatus;
};
